import { render, staticRenderFns } from "./VasionTable.vue?vue&type=template&id=4fd8fc0a&scoped=true"
import script from "./VasionTable.vue?vue&type=script&lang=js"
export * from "./VasionTable.vue?vue&type=script&lang=js"
import style0 from "./VasionTable.vue?vue&type=style&index=0&id=4fd8fc0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd8fc0a",
  null
  
)

export default component.exports